var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllgames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.882 511.882",
    xmlSpace: "preserve",
    fill: "#F9D722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D722"
    },
    d: "M259.171,233.014c-0.125,0.484-12.731,48.484-50.079,104.077 c-34.287,50.984-97.111,119.104-201.798,153.984v0.016C3.061,492.496,0,496.48,0,501.197c0,5.889,4.78,10.668,10.668,10.668 c1.171,0,2.312-0.203,3.358-0.562v0.016c48.907-16.307,93.299-40.769,131.991-72.759c30.928-25.57,58.264-55.952,81.256-90.3 c39.16-58.529,52.031-107.889,52.562-109.951L259.171,233.014z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5C518"
    },
    d: "M55.249,162.536C-9.809,225.47,83.818,283.842,83.818,283.842s-58.029,93.846,28.179,121.4 s169.699-167.667,169.699-167.667S120.307,99.617,55.249,162.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5C518"
    },
    d: "M488.882,317.113c65.058-62.917-28.569-121.306-28.569-121.306s58.029-93.831-28.18-121.385 C345.926,46.868,262.42,242.089,262.42,242.089S423.825,380.047,488.882,317.113z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC00"
    },
    d: "M194.769,456.649c62.934,65.058,121.307-28.57,121.307-28.57s93.847,58.029,121.4-28.178 c27.554-86.209-167.667-160.373-167.667-160.373S131.85,391.59,194.769,456.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC00"
    },
    d: "M349.346,23.016c-62.918-65.058-121.307,28.569-121.307,28.569s-93.83-58.029-121.384,28.179 c-27.57,86.208,163.154,159.764,163.154,159.764S412.281,88.074,349.346,23.016z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllgames);
export default __webpack_public_path__ + "static/media/all games.35706f9553fdc5f5b2fb8a007301678d.svg";
export { ForwardRef as ReactComponent };